export default {
  // Navbar
  "nav.about": "About Us",
  "nav.maintenance": "Services",
  "nav.satellite": "Satellite Comm",
  "nav.security": "Solutions",
  "nav.performance": "Track Record",
  "nav.support": "Support",
  "nav.contact": "Contact Us",

  // Hero
  "hero.badge": "SHIP IT SUPPORT · VESSEL IT EXPERT · SINCE 2019",
  "hero.live": "24/365 HELPDESK ONLINE",
  "hero.title1": "Vessel IT",
  "hero.title2": "Integrated Management Partner",
  "hero.desc1": "A vessel IT specialist dedicated to safe navigation.",
  "hero.desc2": "Ocean Connect manages the IT assets of 200+ vessels 24/365.",

  // Performance
  "perf.heading1": "Trust proven",
  "perf.heading2": "by numbers",
  "perf.stat1.d": "Vessels currently managed",
  "perf.stat2.d": "Vessels supported in total",
  "perf.stat3.d": "Service cases (86 months uninterrupted)",
  "perf.stat4.d": "Remote immediate resolution rate",
  "perf.stat5.d": "Onboard jobs (749 trips)",
  "perf.stats.note": "Based on service records from May 2019 to June 2026",
  "perf.card1.title": "Service Track Record",
  "perf.card1.desc": "We currently run integrated IT maintenance for 200+ vessels, maintaining long-term contracts with shipping companies and supporting all vessel types — container, bulk, tanker, PCTC, and gas carriers.",
  "perf.card1.i1": "Integrated IT management for the entire PAN OCEAN owned fleet · 2019–present",
  "perf.card1.i2": "Integrated IT management for STX OCEANSERVICE managed vessels · 2023–present",
  "perf.card1.i3": "Integrated IT management for the entire HANARO SHIPPING owned fleet · 2026–present",
  "perf.card1.i4": "Satellite commissioning for KDDI managed vessels · fleet-wide security equipment deployment",
  "perf.card2.title": "On-site & Remote Capability",
  "perf.card2.desc": "We resolve issues immediately at sea through remote support, and board vessels ourselves — at Korean ports and at overseas shipyards for newbuilds.",
  "perf.card2.i1": "14,369 remote support cases · 93.5% remote immediate resolution",
  "perf.card2.i2": "375 onboard inspections (202 vessels) · 312 newbuild (104 vessels) · 304 install/repair",
  "perf.card2.i3": "991 onboard jobs · 749 trips · 1,207 deployed days",
  "perf.card2.i4": "151 overseas shipyard newbuild visits · 60%+ of newbuild/takeover visits overseas",
  "perf.more": "Contact Us",

  // Partners
  "partners.title": "Working with shipping, telecom, and equipment partners",
  "partners.desc": "Through partnerships with shipping companies such as PAN OCEAN, STX OCEANSERVICE, and HANARO SHIPPING, telecom operators such as KDDI, and equipment suppliers, we deliver global maritime IT services.",

  // News
  "news.heading": "Ocean Connect News",
  "news.sub": "Check notices, business news, technical resources, and career information.",
  "news.viewall": "View All Notices",
  "news.more": "Learn More",
  "news.n1.cat": "Notice",
  "news.n1.title": "Ocean Connect website renewal open",
  "news.n1.excerpt": "The new website of Ocean Connect, a vessel IT integrated management solution specialist, is now open.",
  "news.n2.cat": "Business",
  "news.n2.title": "Integrated IT management contract with HANARO SHIPPING",
  "news.n2.excerpt": "We have started integrated IT management for the entire HANARO SHIPPING owned fleet, including onboard visits, remote support, and ship supply.",
  "news.n3.cat": "Tech Note",
  "news.n3.title": "Starlink Maritime installation & commissioning checklist for ships",
  "news.n3.excerpt": "Antenna location, UPS, firewall integration, VSAT failover, testing and handover — a six-step checklist for integrating Starlink into the onboard network properly.",
  "news.n4.cat": "Tech Note",
  "news.n4.title": "IACS UR E26 & E27 guide: cyber resilience of ships and on-board systems",
  "news.n4.excerpt": "What IACS UR E26 / E27 require for ships contracted after July 2024, the most common audit findings, and how Ocean Connect addresses them.",
  "news.n16.cat": "Tech Note",
  "news.n16.title": "Marine CCTV camera installation guide for ships: placement, recorders and protection at sea",
  "news.n16.excerpt": "Where to put marine CCTV cameras on a ship, how to cope with vibration, salt, humidity and night-time glare, recorder storage and time sync, network separation and security, and routine recording checks.",
  "news.n15.cat": "Tech Note",
  "news.n15.title": "Choosing a satellite phone for ships: fixed vs handheld and how Inmarsat service works",
  "news.n15.excerpt": "Why ships keep a satellite phone alongside their internet link, how Inmarsat GSPS coverage, numbers and SIMs work, fixed phones versus the handheld IsatPhone 2, antenna placement and emergency routines.",
  "news.n14.cat": "Tech Note",
  "news.n14.title": "Reading a digital inclinometer on ships: roll and pitch in cargo work and heavy weather",
  "news.n14.excerpt": "How to read roll and pitch as a steady offset and a swing, what to watch during cargo work and in heavy weather, and how to replay records and check odd readings on an electronic ship inclinometer.",
  "news.n13.cat": "Tech Note",
  "news.n13.title": "Digital inclinometer for ships: how to choose an electronic inclinometer and where to install it",
  "news.n13.excerpt": "Digital vs pendulum inclinometers, what to check when choosing one, installation and zero-point checks, and how it is used in cargo work and heavy weather.",
  "news.n12.cat": "Tech Note",
  "news.n12.title": "Cyber security manual for ships: what the manual and incident response procedure must include",
  "news.n12.excerpt": "Scope and responsibilities, day-to-day rules, the five steps of incident response, writing for life at sea, and how to test and revise a ship cyber security manual.",
  "news.n11.cat": "Tech Note",
  "news.n11.title": "IACS UR E26 & E27 checklist: asset inventory, network segmentation and evidence",
  "news.n11.excerpt": "A practical order of preparation for UR E26 and E27: asset inventory, network segmentation, protection measures, detection and response, and the evidence to keep for audits.",
  "news.n9.cat": "Tech Note",
  "news.n9.title": "Vessel IT management guide: onboard IT systems, maintenance, security and connectivity",
  "news.n9.excerpt": "What vessel IT covers, which IT systems are on board, how managing ship IT differs from shore IT, and the four pillars of vessel IT management — a guide for ship managers.",
  "news.n8.cat": "Tech Note",
  "news.n8.title": "Ship cyber security drill scenarios: 5 exercises for vessel crews",
  "news.n8.excerpt": "Five practical ship cyber security drill scenarios — ransomware, USB malware, phishing e-mail, loss of satellite link and GNSS anomalies — with how to prepare, run and record each drill for your SMS.",
  "news.n7.cat": "Tech Note",
  "news.n7.title": "Maritime cyber security guide for ships: threats, IACS UR E26/E27 and a 5-step framework",
  "news.n7.excerpt": "Ship and vessel cyber security in one overview: why maritime cyber security matters, the main threats to ships, what IMO and IACS rules require, a five-step identify-protect-detect-respond-recover framework and crew security rules — in one overview.",
  "news.n6.cat": "Tech Note",
  "news.n6.title": "Why a loose firewall policy exposes vessels to security incidents",
  "news.n6.excerpt": "A firewall with a loose policy is as good as none. The incidents that actually happen on ships, what loose policies look like, and how to tighten them.",
  "news.n5.cat": "Tech Note",
  "news.n5.title": "7 preventive checks that reduce vessel IT failures",
  "news.n5.excerpt": "Servers and PCs, restore tests, UPS batteries, network equipment, satellite links, security and remote-support readiness — what we check on every onboard visit.",

  // Contact
  "contact.title1": "Building together",
  "contact.title2": "the future of safe navigation",
  "contact.desc": "Need an integrated vessel IT management solution? Ocean Connect's expert engineers provide optimal 24/7 technical support.",
  "contact.info1.title": "Head Office",
  "contact.info1.value": "Room 218, Yongdang Building 9, 365 Sinseon-ro, Nam-gu, Busan",
  "contact.info2.title": "Tel · Fax",
  "contact.info2.value": "T. +82-51-715-0611   |   F. +82-51-715-0613",
  "contact.info3.title": "Email",
  "contact.info3.value": "info@oceanconnect.co.kr",
  "contact.info4.title": "Hours",
  "contact.info4.value": "Weekdays 09:00 - 18:00",
  "contact.info4.hint": "Emergency support 24/7",
  "contact.info5.title": "Helpdesk for Faults (24H)",
  "contact.info5.value": "+82-70-7588-0611 ~ 0612",
  "contact.kakao.title": "KakaoTalk Channel",
  "contact.kakao.value": "오션커넥트 선박 IT 지원",
  "contact.kakao.hint": "Search the channel name in KakaoTalk",
  "contact.success.title": "Your inquiry has been received",
  "contact.success.desc": "A representative will contact you shortly. Thank you.",
  "contact.new": "Write a New Inquiry",
  "contact.form.name": "Name",
  "contact.form.company": "Company / Organization",
  "contact.form.email": "Email",
  "contact.form.phone": "Phone",
  "contact.form.category": "Inquiry Type",
  "contact.form.message": "Message",
  "contact.placeholder.name": "Hong Gil-dong",
  "contact.placeholder.company": "○○ Shipping",
  "contact.placeholder.phone": "010-0000-0000",
  "contact.category.default": "Select an inquiry type",
  "contact.category.maintenance": "Integrated Vessel IT Maintenance",
  "contact.category.network": "Network Deployment · Consulting",
  "contact.category.satellite": "Satellite Installation · Commissioning",
  "contact.category.security": "Cyber Security (Firewall · Endpoint · USB)",
  "contact.category.newbuild": "Newbuild · Takeover Vessel IT Setup",
  "contact.category.parts": "IT Equipment · Ship Supply",
  "contact.category.etc": "Other Inquiries",
  "contact.placeholder.message": "Please enter your inquiry. (Max 500 characters)",
  "contact.agree": "I agree to the collection and use of personal information. Collected information is used only for responding to inquiries.",
  "contact.err.length": "Please keep your message within 500 characters.",
  "contact.form.note": "Our team will review your inquiry and get back to you at the contact details provided. For urgent issues, please call our 24H helpdesk at +82-70-7588-0611.",
  "contact.err.fail": "Failed to send your inquiry. Please try again later or call +82-51-715-0611.",
  "contact.err.network": "A network error occurred. Please try again later or call +82-51-715-0611.",
  "contact.submit": "Submit Inquiry",
  "contact.sending": "Sending...",

  // SEO
  "seo.home.title": "Ship IT Support · Vessel IT Support · Maritime IT Services",
  "seo.home.desc": "Ocean Connect, a Busan-based maritime IT company — Ship IT Support and Vessel IT Support for 200+ vessels: vessel IT maintenance, ship network build, VSAT/STARLINK satellite commissioning, maritime cyber security and remote management, with 24-hour emergency response.",
  "seo.solutions.title": "Maritime Cyber Security Solutions for Ships & Vessels",
  "seo.solutions.desc": "Maritime cyber security for ships by Ocean Connect — ship cyber security and vessel cyber security in one system: vessel firewall (UTM), endpoint and USB security, vessel remote management (OCEAN-SUPPORT™), network monitoring (Ocean-Spider™), fleet firewall automation, and marine equipment such as CITADEL and CCTV.",

  // Home: FAQ
  "faq.eyebrow": "FAQ",
  "faq.title": "Frequently Asked Questions",
  "faq.q1": "What does vessel IT maintenance cover?",
  "faq.a1": "Preventive inspection and fault recovery for all onboard IT equipment — PCs, servers, networks, firewalls, UPS, printers, CCTV — plus IT setup for newbuild and takeover vessels and supply of IT equipment and ship stores. Ocean Connect manages the IT of 200+ vessels.",
  "faq.q2": "Can you support vessels remotely while at sea?",
  "faq.a2": "Yes. Our in-house remote management platform OCEAN-SUPPORT™ connects securely to vessel PCs and servers even over low-bandwidth satellite links. Our immediate remote resolution rate is 93.5%, and PCs that cannot boot can be recovered remotely via our PE USB.",
  "faq.q3": "Do you handle VSAT and STARLINK fault response and commissioning?",
  "faq.a3": "Yes. We have deep expertise in maritime communications and vessel email solutions. We respond to faults on every maritime communication system — VSAT, FBB, Iridium, Starlink Maritime, LTE — and provide an end-to-end solution from commissioning and onboard network integration to first-line resolution of communication faults at sea.",
  "faq.q4": "How do you handle maritime cyber security?",
  "faq.a4": "We deploy UTM firewalls, OT/IT network separation, and endpoint and USB security fleet-wide, and monitor the onboard network in real time with our Ocean-Spider™ platform, including evidence generation for class cyber security rules.",
  "faq.q5": "Which areas and hours do you cover?",
  "faq.a5": "From our Busan head office we board vessels at major Korean ports — Busan, Ulsan, Gwangyang, Yeosu, Pohang, Incheon, Pyeongtaek — and support overseas ports through remote access and travel. Our emergency helpdesk (+82-70-7588-0611~0612) responds 24 hours a day.",
  "faq.more": "Explore Services",

  // Home: intro
  "intro.eyebrow": "SHIP IT SUPPORT · VESSEL IT SUPPORT · MARITIME IT",
  "intro.line1": "We manage the IT of 200+ vessels at sea",
  "intro.line2": "from shore, as one integrated system.",
  "intro.desc": "Vessel IT maintenance, ship network build, satellite commissioning, maritime cyber security and remote management — combined into one system by a Busan-based maritime IT company that acts as our clients' own vessel IT team.",
  "intro.stat1": "Vessels currently managed",
  "intro.stat2": "Service cases (86 months uninterrupted)",
  "intro.stat3": "Remote immediate resolution",
  "intro.fleetNote": "Including the entire owned fleets of PAN OCEAN, STX OCEANSERVICE and HANARO SHIPPING",
  "intro.platform.title": "In-house platforms",
  "intro.platform.desc": "OCEAN-SUPPORT™ remote management · Ocean-Spider™ network monitoring",
  "intro.stat4":"Always-on response",
  "intro.note": "Based on service records from May 2019 to June 2026",
  "intro.more": "About Us",

  // Home: business cards
  "cards.eyebrow": "BUSINESS AREAS",
  "cards.title1": "Everything for vessel IT,",
  "cards.title2": "all in Ocean Connect",
  "cards.desc": "Our three business areas integrate vessel IT — from maintenance and satellite communication to cyber security and remote management.",
  "cards.c1.title": "Services",
  "cards.c1.desc": "24/365 integrated vessel IT maintenance, network build & consulting, newbuild & takeover IT setup",
  "cards.c2.title": "Solutions",
  "cards.c2.desc": "Maritime cyber security (firewall · endpoint · USB security), RMM remote management, CITADEL · CCTV and marine equipment",
  "cards.c1.alt": "Vessel IT maintenance on board",
  "cards.c2.alt": "Maritime cyber security and remote management solutions",
  "cards.c3.alt": "Vessel satellite communication VSAT antenna",
  "cards.c3.title": "Satellite Comm",
  "cards.c3.desc": "VSAT · FBB · IRIDIUM · STARLINK installation & commissioning, first-line response to faults at sea",

  // Solutions page
  "solutions.title": "Maritime Cyber Security & Remote Management Solutions",
  "solutions.desc": "Ship cyber security and vessel cyber security solutions — firewall, endpoint and USB security — plus remote management and the communication and safety equipment Ocean Connect supplies, installs, and commissions.",
  "solutions.comingSoon": "Coming soon",
  "solutions.comingSoonDesc": "This solution is in preparation. Coverage will be expanded in phases by agreement.",
  "solutions.more": "Learn More",
  "solutions.cta.title": "Inquire",
  "solutions.cta.desc": "We will recommend a configuration and quotation suited to your vessels and fleet size.",
  "solutions.cta.button": "Contact Us",
  "solutions.related": "Related Solutions",
  "solutions.screens": "Screens",
  "solutions.back": "Back to Solutions",

  // Notice page
  "notice.title": "Notices",
  "notice.desc": "Notices, business news, technical resources, and career information from Ocean Connect.",
  "notice.prev": "Prev",
  "notice.next": "Next",
  "notice.list": "List",
  "notice.related": "Related articles",

  // Careers page
  "careers.title": "Careers",
  "careers.duties": "Responsibilities",
  "careers.requirements": "Requirements",
  "careers.preferred": "Preferred",
  "careers.benefits": "Benefits & Work Environment",
  "careers.apply": "Apply by Email",

  // Downloads page
  "downloads.title": "Resources",

  // Legal
  "legal.effective": "Effective",

  // 404
  "notfound.title": "Page not found",
  "notfound.desc": "The address may be incorrect, or the page may have been moved or removed.",
  "notfound.home": "Go to Home",

  // Footer
  "footer.desc": "A vessel IT integrated management specialist. We keep vessels sailing safely with maintenance, satellite communication, cyber security, remote management and 24-hour emergency support.",
  "footer.g1.title": "About Us",
  "footer.g1.l1": "Company Overview",
  "footer.g1.l2": "Organization",
  "footer.g1.l3": "Track Record",
  "footer.g1.l4": "History",
  "footer.g2.title": "Services",
  "footer.g2.l1": "Integrated IT Maintenance",
  "footer.g2.l2": "Network Build · Consulting",
  "footer.g2.l3": "Installation · Commissioning",
  "footer.g2.l4": "Newbuild · Takeover IT",
  "footer.g3.title": "Solutions",
  "footer.g3.l1": "Firewall · Endpoint",
  "footer.g3.l2": "USB Security",
  "footer.g3.l3": "RMM Remote Management",
  "footer.g3.l4": "NMS Network Monitoring",
  "footer.g4.title": "Satellite Comm",
  "footer.g4.l1": "VSAT · FBB · IRIDIUM",
  "footer.g4.l2": "STARLINK Maritime",
  "footer.g4.l3": "CITADEL Emergency Comm",
  "footer.g4.l4": "Vessel Email",
  "footer.g5.title": "Support",
  "footer.g5.l1": "Online Inquiry",
  "footer.g5.l2": "Careers",
  "footer.g5.l3": "Downloads",
  "footer.g5.l4": "Notices",
  "footer.company": "Ocean Connect Co., Ltd.",
  "footer.ceo": "| CEO Lee Jun-won | Business Reg. No. 618-87-01330 | Room 218, Yongdang Building 9, 365 Sinseon-ro, Nam-gu, Busan, Korea",
  "footer.helpdesk": "24H Helpdesk +82-70-7588-0611 ~ 0612",
  "footer.tel": "T. +82-51-715-0611",
  "footer.fax": "F. +82-51-715-0613",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Use",
  "footer.copyright": "© {{year}} OCEAN CONNECT CO., LTD. All Rights Reserved.",
};
